

import { default as Component } from './component';
// import * as ComponentMap from './components'
console.log("aqui si ");
export default {

  install(Vue, options)
  {
    // register all components globall

    // $dayspan is just another reactive component
    var $dayspan = new Vue( options?Component: Component );

    // allow directives to access $dayspan
    Vue.$dayspan = $dayspan;

    // allow components to access $dayspan
    Vue.prototype.$dayspan = $dayspan;
  

   

    // Call initialization functions
    // $dayspan.init();
  }

};
